import http from "@/http/aisea/axios";
const resource = "/enterprises/crews/alerts/settings";

/**
 * 法人アラート設定API
 */
export default {
  /**
   * 法人アラート設定を取得する
   */
  fetch() {
    return http.get(`${resource}`);
  },
};
